import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { getAllFavourites } from "../../api";
import { Nodata } from "../../assets";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";
import Header from "../Header/Header";
import FeedDetail from "../Home/FeedDetail";

const Favourites = () => {
  const { uid } = useParams();
  const effectRun = useRef();

  const [{ favourites }, dispatch] = useStateValue();

  useEffect(() => {
    // if (effectRun.current === true) {
    dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });

    if (!favourites || favourites?.length === 0) {
      getAllFavourites(uid).then((data) => {
        dispatch({ type: actionType.SET_FAVOURITES, favourites: data.data });
      });
    }

    setTimeout(() => {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
    }, 3000);
    // }
    return () => {
      // effectRun.current = true;
    };
  }, []);

  return (
    <div className="w-full h-auto flex flex-col items-center justify-center">
      <Header />
      <div className=" w-full px-6 md:px-24 flex flex-wrap items-center justify-between gap-6 gap-y-10 mt-8">
        {favourites && favourites?.length > 0 ? (
          favourites.map((concept, i) => (
            <FeedDetail key={i} index={i} data={concept} />
          ))
        ) : (
          <div className="w-full flex items-center justify-center gap-4 flex-col">
            <p className="text-4xl text-textColor font-semibold">
              No Favourites
            </p>
            <img src={Nodata} className="w-full md:w-508" alt="" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Favourites;
